/* eslint-disable */
import HttpClient from "../../shared-module/utilities/http-client";

const { ProtectedHttpClient } = HttpClient;

/**
 endpoints to schedule messages
    ScheduleEmail: [POST] /api/schedule/email
    ScheduleIVR: [POST]/api/schedule/ivr
    ScheduleSMS: [POST] /api/schedule/sms
    ListScheduleEmail: [POST] /api/schedule/email/list
    ListScheduleIVR: [POST] /api/schedule/ivr/list
    ListScheduleSMS: [POST] /api/schedule/sms/list
    DeleteScheduleEmail: [DELETE] /api/schedule/email/delete/{id}
    DeleteScheduleIVR: [DELETE] /api/schedule/ivr/delete/{id}
    DeleteScheduleSMS: [DELETE] /api/sms/schedule/delete/{id}
 */
const IVRApi = {
  public: {},
  private: {
    /**
     *  To initiate single ivr (or with multiple phones)
     */
    initiateCall: payload => ProtectedHttpClient.post(`/flow/send`, payload),
    /**
     *  To initiate bulk ivr
     */
    initiateBulkCall: payload => ProtectedHttpClient.post(`/flow/massend`, payload),
    /**
     *  To create a new automated message (schedule)
     */
    schedule: payload => ProtectedHttpClient.post(`/schedule`, payload),
    /**
     *  To fetch all schduled IVRs
     */
    fetchScheduledList: payload => ProtectedHttpClient.post(`/schedule/list`, payload),
    /**
     *  To edit an automated IVR (schedule)
     */
    updateScheduledIVR: payload => ProtectedHttpClient.post(`/schedule/ivr`, payload),
    /**
     *  To delete an automated IVR (schedule)
     */
    deleteScheduledIVR: id => ProtectedHttpClient.delete(`/schedule/delete/${id}`),
    /**
     *  To toggle pause of an automated ivr (schedule)
     */
    togglePause: (id, payload) => ProtectedHttpClient.put(`/schedule/pause/${id}`, payload)
  }
};
export default IVRApi;
